import type { FC, ReactNode } from 'react'

import Head from 'next/head'
import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import AppSection from '@/components/landing/app-section'
import ContactSection from '@/components/landing/contact-section'
import CoursesSection from '@/components/landing/courses-section'
import DiagnosticsSection from '@/components/landing/diagnostics-section'
import FaqSection from '@/components/landing/faq-section'
import HeroSection from '@/components/landing/hero-section'
import JourneySection from '@/components/landing/journey-section'
import LeadershipSection from '@/components/landing/leadership-section'
import RecruitersSection from '@/components/landing/recruiters-section'
import SectorsMarquee from '@/components/landing/sectors-marquee'
import StoriesSection from '@/components/landing/stories-section'
import WhySection from '@/components/landing/why-section'

import { siteConfig } from '@/constants/site'
import { CONTACT, LINKS } from '@/constants/landing'

const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: 'Skillkafe',
    alternateName: 'Skill Kafe',
    url: 'https://skillkafe.in/',
    description: siteConfig.description,
    email: CONTACT.email,
    telephone: '+91-90882-03800',
    address: {
        '@type': 'PostalAddress',
        streetAddress: "20C Ballygunge Station Road, Indroneel Building, Ground Floor",
        addressLocality: 'Kolkata',
        addressRegion: 'West Bengal',
        postalCode: '700019',
        addressCountry: 'IN'
    },
    sameAs: [LINKS.facebook, LINKS.instagram, LINKS.linkedin]
}

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo ogImage={siteConfig.ogImage} />

            <Head>
                <script
                    type='application/ld+json'
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
                />
            </Head>

            <HeroSection />
            <SectorsMarquee />
            <CoursesSection />
            <DiagnosticsSection />
            <JourneySection />
            <WhySection />
            <RecruitersSection />
            <StoriesSection />
            <LeadershipSection />
            <AppSection />
            <FaqSection />
            <ContactSection />
        </Layout>
    )
}

export default Home
